import { AppLogo } from '@/config';
import { AppUrls } from '@/urls';
import React from 'react';
import { Link } from 'react-router-dom';

export default function UnAuthorizedHeader() {
  return (
    <>
      <header className={`header is-sticky bg-white`}>
        <div className="header__container px-30 sm:px-20">
          <div className="row justify-between items-center">
            <div className="col-auto">
              <div className="d-flex items-center">
                <Link to={AppUrls.HomePage} className="header-logo mr-20">
                  <AppLogo />
                </Link>

                <div className="header-menu">
                  <div className="header-menu__content"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </header>
    </>
  );
}
